import React, { useMemo } from 'react';
import {
  MembershipOrganizationBusiness,
  MembershipOrganizationUnit,
} from 'works/legacy/graphql/works-membership';
import { groupBy } from 'lodash';
import { Collapse, Col, Row } from '@common/components';
import { FontSize } from '@common/tokens';

type Props = {
  organizationBusinesses: MembershipOrganizationBusiness[];
  organizationUnits: MembershipOrganizationUnit[];
};

export function MemberViewDrawerFacilities({
  organizationBusinesses,
  organizationUnits,
}: Props) {
  const organizationBusinessesWithUnits = useMemo(() => {
    const indexedUnits = groupBy(
      organizationUnits,
      (unit) => unit.organizationBusiness.id
    );

    return organizationBusinesses.map((business) => ({
      organizationBusiness: business,
      organizationUnits: indexedUnits[business.id] || [],
    }));
  }, [organizationBusinesses, organizationUnits]);

  return (
    <>
      <Row gutter={[0, 12]} className="member-view-drawer-facilities">
        <Col span={24}>
          <Collapse accordion>
            {organizationBusinessesWithUnits.map(
              ({ organizationBusiness, organizationUnits }) => (
                <Collapse.Panel
                  title={
                    <label className="member-view-drawer-facilities__collapse-label">
                      {organizationBusiness.name} ({organizationUnits.length}/
                      {organizationBusiness.organizationUnitsActiveCount})
                    </label>
                  }
                  key={organizationBusiness.id}
                  className="member-view-drawer-facilities__collapse"
                >
                  <ul className="member-view-drawer-facilities__list">
                    {organizationUnits.map((organizationUnit, index) => (
                      <li
                        key={organizationUnit.id}
                        className="member-view-drawer-facilities__list-item"
                        style={{
                          marginBottom:
                            index === organizationUnits.length - 1 ? 0 : 12,
                        }}
                      >
                        {organizationUnit.name}
                      </li>
                    ))}
                  </ul>
                </Collapse.Panel>
              )
            )}
          </Collapse>
        </Col>
      </Row>
      <style jsx>{`
        :global(.member-view-drawer-facilities h4.ant-typography) {
          font-weight: 400;
          font-size: ${FontSize.md};
          line-height: 26px;
        }
        :global(.member-view-drawer-facilities__list-item) {
          font-size: ${FontSize.md};
          list-style: disc;
        }
        :global(.member-view-drawer-facilities__list) {
          margin-bottom: 0;
          padding-left: 24px;
        }
        :global(.member-view-drawer-facilities) {
          padding-top: 4px;
        }
      `}</style>
    </>
  );
}
